import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '首页', to: '/' },
  { label: '影视作品', to: '/category' },
  { label: '最新资讯', to: '/news' },
  { label: '演员介绍', to: '/about' },
];

const genreLinks = [
  { label: '剧情作品', to: '/category?genre=剧情' },
  { label: '悬疑作品', to: '/category?genre=悬疑' },
  { label: '都市作品', to: '/category?genre=都市' },
  { label: '古装作品', to: '/category?genre=古装' },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="w-full max-w-content mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-film-line text-lg" />
              </span>
              <span className="font-heading font-bold text-xl text-background-50">夏目彩春</span>
            </div>
            <p className="text-sm leading-relaxed text-background-100/80 max-w-md">
              夏目彩春影迷平台，汇聚最新影视资讯、人物简介及多部影视作品介绍。我们致力于为影迷提供准确、丰富且更新及时的影视资讯与作品信息。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {['ri-weibo-fill', 'ri-wechat-line', 'ri-instagram-line', 'ri-youtube-line'].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 text-background-100 hover:bg-accent-500 hover:text-background-50 transition-colors cursor-pointer"
                >
                  <i className={icon} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4 text-sm tracking-wide">网站导航</h4>
            <ul className="flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-background-100/80 hover:text-accent-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4 text-sm tracking-wide">按题材浏览</h4>
            <ul className="flex flex-col gap-2.5">
              {genreLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-background-100/80 hover:text-accent-400 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/15 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-100/60">
            © {new Date().getFullYear()} 夏目彩春影迷平台 · 本站内容仅供演示参考
          </p>
          <p className="text-xs text-background-100/60">本站不含在线播放与下载功能</p>
        </div>
      </div>
    </footer>
  );
}